
<template>
  <div>
    <div>
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh" style="min-height:100vh;">
        <div v-if="list.length>0">
          <ul style="background:#F4F1F2;" :class="list.length>3?'ulOneCart Ulmargin':'ulOneCart'">
            <li
              v-for="(item,index) in list"
              :class="{move:candelete.id==item.id}"
              @touchstart="touchStart(item,index)"
              @touchend="touchEnd(item)"
              :key="index"
            >
              <div class="Cartleft">
                <van-checkbox-group v-model="result" ref="checkboxGroup" @change="checkboxTrue" v-if="item.invalid===0">
                  <van-checkbox :name="item.id" checked-color="#B5282D" bind-group ></van-checkbox>
                </van-checkbox-group>
                <div v-else class="Invalid">失效</div>
              </div>
              <dl @click="goHome(item)">
                <dt><img :src="item.productPic" alt=""></dt>
                <dd>
                  <p style="float:left;margin-top:2%;margin-right:2%;" v-if="item.supplierCode=='ZY'" class="ZY">自营</p>
                  <p class="abroad" style="float:left;margin-top:2%;margin-right:2%;" v-if="item.houniaoAbroadStatus==1">海外</p>
                  <p class="Name">{{item.productName }}</p>
                  <p class="productSubTitle ">{{item.productAttr}}</p>
                  <p class="price ">￥{{item.price }}</p>
                  <div style="display:flex;justify-content: space-between;align-items:baseline ;">
                    <div class="discountPrice">折扣￥{{item.discountPrice}}</div>
                      <div style="display:flex;justify-content: space-between;" class="between">
                        <button @click="subtraction(item.id)" class="btnStyle" style="border-right:none;">－</button>
                        <div class="field_div">{{item.num}}</div>
                        <!-- <van-field v-model.number="item.num" @keyup='blacka' :formatter="formatter"  @blur='inputblur(item.id)' type="digit" class="digit" input-align="center" /> -->
                        <button  @click="addition(item.id)" :disabled="disable"  class="btnStyle" style="border-left:none;">＋</button>
                      </div>
                    </div>
                </dd>
              </dl>
              <div class="del" @click="deleteItem(item.id,index)">删除</div>
            </li>
          </ul>
        </div>
        <div v-else>
          <van-empty
              class="custom-image"
              :image="require('@/assets/NotSelected.png')"
              description="还没有选购商品呢"
            />
          <!-- <div class="elseid">
            <div>
              <img src="@/assets/NotSelected.png" alt="" style="">
            </div>
            <div></div>
          </div> -->
        </div>
      </van-pull-refresh>
    </div>
    <div class="absolute" v-if="list.length>0">
      <van-checkbox v-model="checked" class="placeleft" checked-color="#B5282D" @click="toggleAll">
        <span style="padding-left:10px;" class="fz">{{Selection}}</span>
      </van-checkbox>
      <div class="picePlace">￥{{TotalPrice}}</div>
      <div><van-button type="danger" @click="PlaceAnOrder">下单</van-button></div>
    </div>
  </div>
</template>
<script>
import { cartItemList, updateQuantity, address, cartItemdelete } from '../../request/api'
import { Field, Toast, Dialog, Checkbox, CheckboxGroup, Button, PullRefresh, Empty } from 'vant'
// import { kInputFromiOS } from '../../components/interactive'

export default {
  components: {
    [Field.name]: Field,
    [Toast.name]: Toast,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Button.name]: Button,
    [PullRefresh.name]: PullRefresh,
    [Empty.name]: Empty,
    [Dialog.Component.name]: Dialog.Component
  },
  data() {
    return {
      list: [],
      clientNum: {}, // 记录开始滑动（x1）,结束滑动（x2）的鼠标指针的位置
      candelete: {}, // 滑动的item
      disable: false,
      stock: 100,
      index: 1,
      listNum: 1,
      result: [],
      checked: false,
      Selection: '全选',
      TotalPrice: 0,
      addressid: 0,
      isLoading: false
    }
  },
  computed: {
    // 总价
    totalPrice: function() {
      var totalPrice = 0
      console.log(totalPrice)
      var len = this.list.length
      for (var i = 0; i < len; i++) {
        if (this.list[i].invalid !== 1) {
          console.log(this.list[i])
          totalPrice += (this.list[i].price * 1 - this.list[i].discountPrice * 1) * this.list[i].num * 1
        }
      }
      console.log(totalPrice)
      return totalPrice
    }
  },
  methods: {
    // 删除
    deleteItem(id, index) {
      console.log(id)
      // splice方法是删除数组某条数据，或者向某个位置添加数据
      cartItemdelete({ ids: id }).then(res => {
        if (res.code === 200) {
          this.list.splice(index, 1)
          if (this.result.indexOf(id) !== -1) {
            var indexId = this.result.indexOf(id)
            this.result.splice(indexId, 1)
          }
          this.Compoument()
        }
        console.log(res)
      }).catch(res => {
        console.log(res)
      })
    },
    touchStart(item, index) {
      console.log(index)
      this.stock = item.stock
      this.index = index
      const touchs = event.changedTouches[0]
      // 记录开始滑动的鼠标位置
      this.clientNum.x1 = touchs.pageX
      this.stop()
    },
    stop() {
      var mo = function(e) { e.preventDefault() }
      document.body.style.overflow = 'hidden'
      document.addEventListener('touchmove', mo, false)// 禁止页面滑动
    },
    // 取消滑动限制
    move() {
      var mo = function(e) { e.preventDefault() }
      document.body.style.overflow = ''// 出现滚动条
      document.removeEventListener('touchmove', mo, false)
    },
    touchEnd(item) {
      const touchs = event.changedTouches[0]
      // 记录结束滑动的鼠标位置
      this.clientNum.x2 = touchs.pageX
      this.candelete = {}
      // 判断滑动距离大于50，判定为滑动成功，否则失败
      if (
        this.clientNum.x2 < this.clientNum.x1 &&
      Math.abs(this.clientNum.x1) - Math.abs(this.clientNum.x2) > 50
      ) {
        event.preventDefault()
        this.candelete = item
      } else if (
        this.clientNum.x2 > this.clientNum.x1 &&
      Math.abs(this.clientNum.x2) - Math.abs(this.clientNum.x1) > 10
      ) {
        event.preventDefault()
        this.candelete = {}
      }
      this.move()
    },
    // 跳转商品详情页面
    goHome(item) {
      this.listNum = item.num
      console.log(item)
      console.log(event.target.className)
      if (event.target.className === 'btnStyle') {
      } else if (event.target.className === 'van-field__control van-field__control--center') {
      } else {
        this.$router.push({ path: '/CommodityDetails', query: { id: item.productId, skuId: item.defaultSkuId } })
      }
    },
    // 加法
    addition(id) {
      this.list[this.index].num++
      this.blacka(id)
    },
    // 减法
    subtraction(id) {
      this.list[this.index].num--
      if (this.list[this.index].num === 0) {
        this.list[this.index].num = 1
        Dialog.alert({
          message: '小主，不能再减咯'
        }).then(() => {
          // on close
        })
      } else {
        this.blacka(id)
      }
    },
    // 全选反选
    toggleAll() {
      console.log(this.checked)
      if (this.checked) {
        this.list.map(item => {
          if (this.result.indexOf(item.id) === -1) {
            if (item.invalid === 0) {
              this.result.push(item.id)
              console.log(this.result.length)
            }
          }
        })
        this.Selection = '已选' + '(' + this.result.length + ')'
        console.log(this.Selection)
        this.TotalPrice = this.totalPrice
      } else {
        this.result = []
        this.Selection = '全选'
        this.TotalPrice = 0
      }
    },
    // 改变一个选框
    checkboxTrue(names) {
      console.log()
      this.Selection = '已选' + '(' + names.length + ')'
      console.log(names)
      this.result = names
      // console.log(this.result.length)
      var Oneprice = 0
      this.list.map(item => {
        if (names.indexOf(item.id) !== -1) {
          Oneprice = Oneprice * 1
          Oneprice += item.num * (item.price - item.discountPrice)
        }
      })
      this.TotalPrice = Math.floor(Oneprice * 100) / 100
      if (this.list[this.index].ischeckbox) {
        console.log(this.index)
      }
      if (names.length === this.list.length) {
        this.checked = true
      } else {
        this.checked = false
      }
    },
    // 下单
    PlaceAnOrder() {
      console.log(this.result)
      if (this.result.length < 1) {
        // Dialog.alert({
        //   message: '小主，请选择商品哟'
        // }).then(() => {
        //   // on close
        // })
        Toast({
          message: '请选择下单商品',
          icon: 'cross'
        })
      } else {
        const Resultjoin = this.result.join(',')
        console.log(Resultjoin)
        this.$router.push({ path: '/OrderPage', query: { Cart: Resultjoin } })
      }
    },
    Compoument() {
      var Oneprice = 0
      this.list.map(item => {
        if (this.result.indexOf(item.id) !== -1) {
          Oneprice = Oneprice * 1
          Oneprice += item.num * (item.price - item.discountPrice)
        }
      })
      this.TotalPrice = Math.floor(Oneprice * 100) / 100
      console.log(this.result)
      this.Selection = '已选' + '(' + this.result.length + ')'
    },
    // 失去焦点发送数据
    inputblur(id) {
      const params = {
        id: id,
        quantity: this.list[this.index].num
      }
      updateQuantity(params).then(res => {
        console.log(res)
      }).catch(res => {
        console.log(res)
      })
      // var num = this.listNum
      // console.log(this.list[this.index].num)
      // if (this.list[this.index].num > 0) {
      // } else {
      // }
    },
    formatter(value) {
      console.log(value * 1)
      return value.replace(/\d/g, '')
    },
    blacka(id) {
      if (this.list[this.index].stock < this.list[this.index].num) {
        this.disable = true
        this.list[this.index].num = this.list[this.index].stock
        Dialog.alert({
          message: '超出库存'
        }).then(() => {
          // on close
        })
      } else {
        this.disable = false
        const params = {
          id: id,
          quantity: this.list[this.index].num
        }
        updateQuantity(params).then(res => {
          if (res.code === 200) {
            this.Compoument()
          }
          console.log(res)
        }).catch(res => {
          console.log(res)
        })
      }
    },
    onRefresh() {
      console.log('下拉刷新')
      cartItemList().then(res => {
        console.log(res)
        if (res.code === 200) {
          setTimeout(() => {
            this.isLoading = false
            this.list = res.data
            if (this.list.length > 0) {
              this.arr = this.list.length
              this.list.map((item, index) => {
                this.$set(item, 'num', item.quantity)
                this.$set(item, 'ischeckbox', false)
              })
            }
          }, 1000)
        }
      }).catch(res => {
        console.log(res)
      })
    }
  },
  created() {
    Toast.loading({
      message: '加载中...',
      forbidClick: true,
      loadingType: 'spinner'
    })
    cartItemList().then(res => {
      console.log(res)
      if (res.code === 200) {
        Toast.clear()
        sessionStorage.setItem('code', res.data.length)
        console.log(sessionStorage.getItem('code'))
        this.isLoading = false
        this.list = res.data
        if (this.list.length > 0) {
          this.arr = this.list.length
          this.list.map((item, index) => {
            this.$set(item, 'num', item.quantity)
            this.$set(item, 'ischeckbox', false)
          })
        }
        // kInputFromiOS('shoppingNumber', sessionStorage.getItem('code'))
        // var message = {
        //   body: 'shoppingNumber',
        //   data: sessionStorage.getItem('code')
        // }
        // var jsonStr = JSON.stringify(message)
        // window.android.getDataFormVue(jsonStr)
      }
    }).catch(res => {
      console.log(res)
    })
    address().then(res => {
      console.log(res)
      this.addressid = res.data[0].id
      console.log(this.addressid)
    }).catch(res => {
      console.log(res)
    })
  }
}
</script>
<style lang="less" scoped>
.Invalid{
  width: 60px;
  height: 40px;
  line-height: 40px;
  background-color: #DCDCDC;
  color: white;
  border-radius: 5px;
  text-align: center;
  font-size: 24px;
}
li{
  margin-bottom: 24px;
  height:226px;
  background:rgba(255,255,255,1);
  position: relative;
  transform: translateX(0);
  transition: all .3s; /*滑动效果更生动*/
  display: flex;
  justify-content: flex-start;
}
ul{
  overflow-x: hidden; /*隐藏ul x轴的滚动条*/
}
// ul li:last-child{
//   margin-bottom: 110px;
// }
li.move {
  transform: translateX(-160px); /*滑动后x轴位移-160px,使其可见*/
}
.del {
  position: absolute;
  top: 0;
  right: -1px;
  z-index: 3;
  width: 160px;
  height: 100%;
  border-radius: 4px;
  text-align: center;
  color: #fff;
  background-color:#B4272D;
  transform: translateX(160px); /*默认x轴位移100px，使其隐藏*/
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 28px;
}
.placeimg {
  width:36px;
  height:36px;
  border-radius:50%;
  img{
    width: 100%;
    height: 100%;
  }
}
.Ulmargin{
  margin-bottom: 100px;
}
.ulOneCart {
  dl{
    dt{
      margin-top: 38px;
      width: 150px;
      height: 150px;
      float: left;
      margin-right: 24px;
      img{
        width: 100%;
        height: 100%;
      }
    }
    dd{
      margin-top: 38px;
      float: left;
      width: 450px;
      .Name{
        height: 36px;
        margin-top: 2%;
        font-size: 28px;
        color: #333333;
        //多行文本溢出隐藏
        overflow : hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
      .productSubTitle{
        color: #666666;
        margin-top: 6px;
        font-size: 25px;
      }
      .price {
        margin-top: 8px;
        color: #333333;
        font-size: 28px;
      }
      .discountPrice {
        margin-top: 5px;
        padding: 0px 15px;
        color: #DB5E22;
        // width:122px;
        height:36px;
        background:rgba(255,239,227,1);
        border-radius:4px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 24px;
      }
    }
  }
}
.Cartleft {
  width: 90px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.ZY{
    color: white;
    padding:2px 12px;
    font-size: 24px;
    border-radius: 4px;
    background-color: #E33F36;
}
  // 海外
  .abroad {
    border: 1px solid #E33F36; /* no*/
    color: #E33F36;
    width: 72px;
    height: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
  }
  .digit /deep/ .van-field__body input {
      line-height: normal;
    }
    /deep/ .van-cell{
      line-height: 83px;
      font-size: 28px;
      padding: 0px;
    }
    /deep/ .field_div{
      width: 130px;
      height: 47px;
      border-top: 1px solid rgba(220,220,220,1);/*no*/
      border-bottom: 1px solid rgba(220,220,220,1);/*no*/
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 28px;
    }
    /deep/ .van-cell__value {
      width: 100%;
      height: 100%;
    }
    /deep/ .van-field__body {
      width: 100%;
      height: 100%;
    }
    .btnStyle{
      width:86px;
      height:51px;
      border:1px solid rgba(220,220,220,1); /*no*/
      border-radius:4px 0px 0px 4px;
      display: flex;
      justify-content: center;
      align-items:center ;
      background-color: #fff;
    }
    .between {
      width: 200px;
    }
    /deep/ .van-cell{
      font-size: 26px;
    }
    .absolute {
      width: 100%;
      position: fixed;
      bottom: 0;
      height:98px;
      background:rgba(255,255,255,1);
      border:1px solid rgba(218,218,218,1);
      display: flex;
      justify-content: space-between;
      align-items: baseline ;
    }
    /deep/ .van-button--danger{
      width:224px;
      height:98px;
      font-size: 32px;
      background:rgba(180,39,45,1);
    }
    .picePlace {
      width: 180px;
      text-align: right;
      font-size: 28px;
      color: rgba(180,39,45,1);
    }
    .placeleft{
      padding-left: 40px;
      width: 275px;
    }
    /deep/ .van-checkbox__icon{
      font-size: 36px;
    }
    .fz{
      font-size: 28px;
      color: #999999;
    }
    /deep/.van-button__text {
      font-size: 28px;
    }
    .elseid{
      height: 1000px;
    }
    /deep/ .van-pull-refresh {
      margin-bottom: 100px;
    }
    //占位符
    /deep/ .van-empty__image{
      width: 269px;
      height: 240px;
      margin-bottom: 30px;
      margin-top: 300px;
    }
    /deep/ .van-empty__description{
      font-size: 28px;
    }
    /deep/ .van-empty__description{
      font-size: 27px;
    }
</style>
